import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import swal from 'sweetalert2';
import { ExcelService } from 'src/app/core/services/excel.service';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-taux-execution',
  templateUrl: './taux-execution.component.html',
  styleUrls: ['./taux-execution.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TauxExecutionComponent implements OnInit {
  public organisation: string;
  public date: any;
  public showExecution = false;
  public executions: any;
  public nombre: any;
  public  key = 'code';
  public reverse = false;
  public p = 1;
  public filter: string;
  public day: any;
  public month: any;
  public _type_organisation: any;
  constructor(
    private _service: AppService,
    private toastrService: ToastrService,
    private loadingBar: LoadingBarService,
    private _excelService: ExcelService,
    private _router: Router,
    private storage: LocalStorageService
  ) { }

  ngOnInit() {
    this.getDateOfDay();
  }

  getDateOfDay() {
    const d = new Date();
    const day = d.getDate();
    const month = d.getMonth() + 1;
    this.month = month;
    day < 10 ? this.day = '0' + day : this.day = day;
    month < 10 ? this.month = '0' + month : this.month = month;
    const year = d.getFullYear();
    this.date = year + '-' + this.month + '-' + this.day;
  }

  exporterTableauPourcentage() {
    this.loadingBar.start();
    const arrayTauxExecution = [];
    for (let i = 0; i < this.executions.organisation?.length; i++) {
      arrayTauxExecution.push(
        {
          'Organisation': this.executions.organisation[i].code,
          'Effectué': this.executions.organisation[i].effectue.percent,
          'Accepté': this.executions.organisation[i].accepte.percent,
          'Validé': this.executions.organisation[i].valide.percent,
          'Approuvé': this.executions.organisation[i].approuve.percent,
        }
      );
    }
    this._excelService.exportAsExcelFile(arrayTauxExecution, 'taux_execution');
    this.loadingBar.stop();
  }

  exporterTableauNombre() {
    this.loadingBar.start();
    const arrayNombreExecution = [];
    for (let i = 0; i < this.nombre.organisation?.length; i++) {
      arrayNombreExecution.push(
        {
          'Organisation': this.executions.organisation[i].code,
          'Effectué': this.executions.organisation[i].effectue.nbre,
          'Accepté': this.executions.organisation[i].accepte.nbre,
          'Validé': this.executions.organisation[i].valide.nbre,
          'Approuvé': this.executions.organisation[i].approuve.nbre,
          'Effectif': this.executions.organisation[i].total.total,
        }
      );
    }
    this._excelService.exportAsExcelFile(arrayNombreExecution, 'taux_execution');
    this.loadingBar.stop();
  }

  rechercher() {
    this.loadingBar.start();
    const data = {
      campagne_id: this.storage.retrieve('idCampagneEiaSelected'),
      type_organisation: this.organisation,
      date: this.date,
    };
    this._service.postData('reporting/taux-execution', data)
      .subscribe({
        next: (res: any) => {
          this.executions = res.data;
          this.nombre = res.data;
          this.showExecution = true;
          this.loadingBar.stop();
        },
        error: (err: any) => {
          this.toastrService.error(err.error.message);
          this.loadingBar.stop();
        },
        complete: () => {
          this.loadingBar.stop();
        }
      });
  }
}
